import { ColorsConfig } from '@ddt-web/config';
import { CellData, TabData } from '@ddt-web/data-service';

export class CommonDataUtil {
	public static createUniqueNames(names: Array<string>): string[] {
		names.forEach(name => {
			let numberOfOccurrences = -1;
			for (let i = 0; i < names.length; i++) {
				if (names[i] === name) {
					numberOfOccurrences++;
				}
				if (names[i] === name && numberOfOccurrences >= 1) {
					names[i] = `${name} (${numberOfOccurrences})`;
				}
			}
		});
		return names;
	}

	public static hasDuplicateNames(names: Array<string>): boolean {
		const originalLength = names.length;
		const uniqueNamesLength = names.filter((name, index, self) => {
			return self.indexOf(name) === index;
		}).length;
		return originalLength !== uniqueNamesLength;
	}

	/**
	 * Get the default colors for the provided tabData, batch and index.
	 *
	 * @param {TabData} data the configured data after the initial API data request has been resolved.
	 * @param {number} portfolioIndex the index of the Portfolio to be processed (defaulted to 0)
	 * @param {number} dataBatch the table data batch (defaulted to 0)
	 */
	public static getDefaultColorsForTabData(data: TabData, portfolioIndex: number = 0, dataBatch: number = 0): Array<string> {
		const indicesToBeRemoved: number[] = [];
		let headers = data.displayConfig.transpose ? data.tableData[dataBatch].headersY : data.tableData[dataBatch].headersX;
		headers = headers.filter(header => !header.attribute.ignoreInChart);

		// filter out the colors for the categories with no holding weight
		data.tableData[dataBatch].cells.forEach((cell, index) => {
			if (cell[portfolioIndex] && cell[portfolioIndex].rawValue === undefined) {
				indicesToBeRemoved.push(index);
			}
		});

		headers = headers.filter((header, index) => !indicesToBeRemoved.includes(index));
		return headers.map((cellData: CellData) => (cellData.attribute && cellData.attribute.colorTheme) || '#ccc');
	}

	public static getCategoriesForTabData(data: TabData): Array<any> {
		const headers = data.displayConfig.transpose ? data.tableData[0].headersY : data.tableData[0].headersX;
		return headers.map((cellData: CellData) => cellData.formattedValue);
	}

	public static getPortfolioColors(): Array<string> {
		return ColorsConfig.PORTFOLIO_COLORS;
	}
}
